import { createContext, useState, useEffect } from "react";

export const WellContext = createContext();

export const WellProvider = ({ children }) => {

  /* =========================
     GLOBAL WELL DATA
  ========================== */
  const [wellData, setWellData] = useState(() => {
  const saved = localStorage.getItem("wellData");
  return saved ? JSON.parse(saved) : {};
});

useEffect(() => {
  localStorage.setItem("wellData", JSON.stringify(wellData));
}, [wellData]);




const [valveData, setValveData ] = useState(() => {
  const saved = localStorage.getItem("valveData");
  return saved
    ? JSON.parse(saved)
    : {};
});

const [transmitters, setTransmitters] = useState({});



useEffect(() => {
  localStorage.setItem("valveData", JSON.stringify(valveData));
}, [valveData]);



  const [testHeaderData, setTestHeaderData] = useState({
      NK1: { fic: 0, pt: 0, tt: 0 },
      NK2: { fic: 0, pt: 0, tt: 0 },
      NK3: { fic: 0, pt: 0, tt: 0 }
    });

   













  /* =========================
     GLOBAL VALVE STATE (PERSISTENT)
  ========================== */
  const [valves, setValves] = useState(() => {
  const saved = localStorage.getItem("global_valves");
  return saved
    ? JSON.parse(saved)
    : {
        DHSV_10101: false,
        SSSV_10102: false,
        XV_10103: false,
        XV_10104: false,
        XV_10105: false,
        XV_10106: false,
        XV_10107: false,
        XV_10108: false,
        XV_10109: false,
        GLV_1: false,
        GLV_2: false,
        GLV_3: false,
        GLV_4: false,
        DHSV_10201: false,
        SSSV_10202: false,
        XV_10201: false,
        XV_10203: false,
        XV_10204: false,
        XV_10205: false,
        XV_10206: false,
        XV_10207: false,
        XV_10208: false,
        XV_10209: false,
        GLV_6: false,
        GLV_7: false,
        GLV_8: false,
        GLV_9: false,
        TT_10101: 0,
        FIC_10102: 0,
        FIC_10100: 0,
        CHK_101: 0,

        TT_10201: 0,
        FIC_10202: 0,
        FIC_10200: 0,
        CHK_102: 0,
      };
});

useEffect(() => {
  localStorage.setItem("global_valves", JSON.stringify(valves));
}, [valves]);

    /* =========================
     UPDATE WELL DATA
  ========================== */
  const updateData = (label, newData) => {
    setWellData(prev => {
      const updated = {
        ...prev,
        [label]: {
          ...prev[label],
          ...newData
        }
      };

      console.log("UPDATED WELL DATA:", updated);

      return updated;
    });
  };

  /* =========================
     TOGGLE VALVE (GLOBAL)
  ========================== */
  const toggleValve = (tag) => {
    setValves(prev => ({
      ...prev,
      [tag]: !prev[tag]
    }));
  };

  

  /* =========================
     TRANSMITTER HELPERS FOR NK-1 WELLHEAD PAGE
  ========================== */
  const getPT10103 = (label) => {
    const data = wellData[label];
    if (!data || !data.pressureInput) return 0;

    const value = Number(data.pressureInput);
    return value - (0.053 * value);
  };

  const getTT10101 = (label) => {
    const data = wellData[label];
    if (!data || !data.temperatureInput) return 0;

    const value = Number(data.temperatureInput);
    return value - (0.016 * value);
  };

    const getPT10104 = (label) => {
    const pt10103 = getPT10103(label);

    if (!pt10103 || isNaN(pt10103)) return 0.003;

    return pt10103 * 0.915;
    };

    const getPT101013 = (label) => {
    const pt10104 = getPT10104(label);

    if (!pt10104 || isNaN(pt10104)) return 0.003;

    return pt10104 * 0.386;
    };

    const getTT10102 = (label) => {
    const tt10102 = getTT10102(label);

    if (!tt10102 || isNaN(tt10102)) return 22;

    return tt10102 * 0.88;
    };

    const getPT10105 = (label) => {
    const pt10105 = getPT10105(label);

    if (!pt10105 || isNaN(pt10105)) return 0.003;

    return pt10105 * 0.73;
    };

    const getTT10105 = (label) => {
    const tt10105 = getTT10105(label);

    if (!tt10105 || isNaN(tt10105)) return 22;

    return tt10105 * 0.90;
    };

    const [mpft10101, setMpft10101] = useState(0);
    const [mpft10102, setMpft10102] = useState(0);
    const [mpft10103, setMpft10103] = useState(0);

    // FIQ value
    const [fiq10101, setFiq10101] = useState(0);

    


    /* =========================
     TRANSMITTER HELPERS FOR NK-2 WELLHEAD PAGE
  ========================== */

    const getPT10203 = (label) => {
    const data = wellData[label];
    if (!data || !data.pressureInput) return 0;

    const value = Number(data.pressureInput);
    return value - (0.053 * value);
  };

    const getTT10201 = (label) => {
    const data = wellData[label];
    if (!data || !data.temperatureInput) return 0;

    const value = Number(data.temperatureInput);
    return value - (0.016 * value);
  };

    const getPT10204 = (label) => {
    const pt10203 = getPT10203(label);

    if (!pt10203 || isNaN(pt10203)) return 0.003;

    return pt10203 * 0.915;
    };

    const getPT102013 = (label) => {
    const pt10204 = getPT10204(label);

    if (!pt10204 || isNaN(pt10204)) return 0.003;

    return pt10204 * 0.386;
    };

    const getTT10202 = (label) => {
    const tt10202 = getTT10202(label);

    if (!tt10202 || isNaN(tt10202)) return 22;

    return tt10202 * 0.88;
    };

    const getPT10205 = (label) => {
    const pt10205 = getPT10205(label);

    if (!pt10205 || isNaN(pt10205)) return 0.003;

    return pt10205 * 0.73;
    };

    const getTT10205 = (label) => {
    const tt10205 = getTT10205(label);

    if (!tt10205 || isNaN(tt10205)) return 22;

    return tt10205 * 0.90;
    };

    const [mpft10201, setMpft10201] = useState(0);
    const [mpft10202, setMpft10202] = useState(0);
    const [mpft10203, setMpft10203] = useState(0);

    // FIQ value
    const [fiq10201, setFiq10201] = useState(0);




     /* =========================
     TRANSMITTER HELPERS FOR NK-3 WELLHEAD PAGE
  ========================== */

    const getPT10303 = (label) => {
    const data = wellData[label];
    if (!data || !data.pressureInput) return 0;

    const value = Number(data.pressureInput);
    return value - (0.053 * value);
  };

    const getTT10301 = (label) => {
    const data = wellData[label];
    if (!data || !data.temperatureInput) return 0;

    const value = Number(data.temperatureInput);
    return value - (0.016 * value);
  };

    const getPT10304 = (label) => {
    const pt10303 = getPT10303(label);

    if (!pt10303 || isNaN(pt10303)) return 0.003;

    return pt10303 * 0.915;
    };

    const getPT103013 = (label) => {
    const pt10304 = getPT10304(label);

    if (!pt10304 || isNaN(pt10304)) return 0.003;

    return pt10304 * 0.386;
    };

    const getTT10302 = (label) => {
    const tt10302 = getTT10302(label);

    if (!tt10302 || isNaN(tt10302)) return 22;

    return tt10302 * 0.88;
    };

    const getPT10305 = (label) => {
    const pt10305 = getPT10305(label);

    if (!pt10305 || isNaN(pt10305)) return 0.003;

    return pt10305 * 0.73;
    };

    const getTT10305 = (label) => {
    const tt10305 = getTT10305(label);

    if (!tt10305 || isNaN(tt10305)) return 22;

    return tt10305 * 0.90;
    };

     const [mpft10301, setMpft10301] = useState(0);
    const [mpft10302, setMpft10302] = useState(0);
    const [mpft10303, setMpft10303] = useState(0);

    // FIQ value
    const [fiq10301, setFiq10301] = useState(0);



       const [wellSignals, setWellSignals] = useState({
        NK1: { fic: 0, pt: 0, tt: 0, fc1: 0, pt1: 0, oil: 0, gas: 0, water: 0},
        NK2: { fic: 0, pt: 0, tt: 0, fc2: 0, pt2: 0, oil: 0, gas: 0, water: 0},
        NK3: { fic: 0, pt: 0, tt: 0, fc2: 0, pt3: 0, oil: 0, gas: 0, water: 0},

    

      });
      const updateWellSignals = (well, data) => {
      setWellSignals(prev => ({
        ...prev,
        [well]: {
          ...prev[well],
          ...data
        }
      }));
    };

    

      const [levels, setLevels] = useState(() => {
      const saved = localStorage.getItem("levels");
      return saved ? JSON.parse(saved) : {};
    });
    useEffect(() => {
        localStorage.setItem("global_levels", JSON.stringify(levels));
      }, [levels]);



  return (
    <WellContext.Provider
      value={{
        wellData,
        updateData,
        valves,
        setValves,
        toggleValve,
        getPT10103,
        getTT10101,
        getPT10104,
        getPT101013,
        getTT10102,
        getPT10105,
        getTT10105,
        mpft10101,
        setMpft10101,
        mpft10102,
        setMpft10102,
        mpft10103,
        setMpft10103,
        fiq10101,
        setFiq10101,

        getPT10203,
        getTT10201,
        getPT10204,
        getPT102013,
        getTT10202,
        getPT10205,
        getTT10205,
        mpft10201,
        setMpft10201,
        mpft10202,
        setMpft10202,
        mpft10203,
        setMpft10203,
        fiq10201,
        setFiq10201,



        getPT10303,
        getTT10301,
        getPT10304,
        getPT103013,
        getTT10302,
        getPT10305,
        getTT10305,
        mpft10201,
        setMpft10301,
        mpft10302,
        setMpft10302,
        mpft10303,
        setMpft10303,
        fiq10301,
        setFiq10301,
        
        wellSignals,
        updateWellSignals,
         transmitters,
        setTransmitters,
        levels,
        setLevels,
      }}
    >
      {children}
    </WellContext.Provider>
  );
};





